import { httpClient } from "./http-clients/http-client";

interface Setting {
    value: string;
}

export const getSettingValue = async (key: string, timeoutMs = 0): Promise<string | null> => {
    try {
        const response = await httpClient.get<Setting>(`/api/setting?key=${key}`, { timeout: timeoutMs });
        return response.data.value;
    } catch {
        return null;
    }
};
